export default {
  getCity(state) {
    return state.cityId;
  }
};
